import React from 'react';
import { motion } from 'framer-motion';
export function Lead() {
  return <section className="py-12 px-4 bg-[#0a0a0f]" data-id="element-93">
      <div className="max-w-2xl mx-auto" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-95">
          <p className="text-gray-300 text-lg leading-relaxed" data-id="element-96">
            No es que no se amen. Es que la vida se les metió en medio. Los
            niños, el trabajo, la casa... y sin darte cuenta, lo que antes era
            cercanía se volvió coordinación.
          </p>
          <p className="text-gray-300 text-lg leading-relaxed mt-4" data-id="element-97">
            En el mes del amor la presión sube, pero si eres honesta... tú no
            quieres un regalo.{' '}
            <span className="text-[#ff2d7a] font-medium" data-id="element-98">
              Quieres volver a sentir conexión real.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}